import { render } from "./ProductCard.vue?vue&type=template&id=7d4a228c&scoped=true"
import script from "./ProductCard.vue?vue&type=script&lang=js"
export * from "./ProductCard.vue?vue&type=script&lang=js"

import "./ProductCard.vue?vue&type=style&index=0&id=7d4a228c&scoped=true&lang=css"

import exportComponent from "F:\\PROJECTS\\2022\\shop2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d4a228c"]])

export default __exports__